import type { MobilePhoneNumberRule } from '@packages/utils/types/mobile-phone-number.ts'

const MOBILE_PHONE_NUMBER_RULES: Record<string, MobilePhoneNumberRule> = {
  1: { hasTrunkZero: false, mobilePattern: /^[2-9]\d{9}$/, maxNationalLength: 10 },
  34: { hasTrunkZero: false, mobilePattern: /^[67]\d{8}$/, maxNationalLength: 9 },
  39: { hasTrunkZero: false, mobilePattern: /^3\d{8,9}$/, maxNationalLength: 11 },
  44: { hasTrunkZero: true, mobilePattern: /^7\d{9}$/, maxNationalLength: 10 },
  45: { hasTrunkZero: false, mobilePattern: /^[2-9]\d{7}$/, maxNationalLength: 8 },
  46: { hasTrunkZero: true, mobilePattern: /^7\d{8}$/, maxNationalLength: 9 },
  47: { hasTrunkZero: false, mobilePattern: /^[49]\d{7}$/, maxNationalLength: 8 },
  48: { hasTrunkZero: false, mobilePattern: /^[4-8]\d{8}$/, maxNationalLength: 9 },
  49: { hasTrunkZero: true, mobilePattern: /^1[5-7]\d{8,9}$/, maxNationalLength: 11 },
  353: { hasTrunkZero: true, mobilePattern: /^8\d{8}$/, maxNationalLength: 9 },
  354: { hasTrunkZero: false, mobilePattern: /^[3-8]\d{6}$/, maxNationalLength: 7 },
  358: { hasTrunkZero: true, mobilePattern: /^(4\d|50)\d{4,8}$/, maxNationalLength: 12 },
  385: { hasTrunkZero: true, mobilePattern: /^9\d{7,8}$/, maxNationalLength: 9 },
}

const OTHER_COUNTRIES_MAX_NATIONAL_LENGTH: Record<string, number> = {
  30: 10,
  31: 9,
  32: 9,
  33: 9,
  41: 9,
  61: 9,
  351: 9,
  356: 8,
  357: 8,
  370: 8,
  371: 8,
  372: 8,
  420: 9,
  421: 9,
}

const ANY_NATIONAL_NUMBER_PATTERN = /^\d{5,14}$/
const MIN_NATIONAL_NUMBER_LENGTH = 5

/** The numeric prefix PHP's (int) cast reads from a string, e.g. " +46", "46.0" or "4.6e1". */
const PHP_NUMERIC_PREFIX_PATTERN = /^[ \t\n\r\v\f]*[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?/

export {
  MOBILE_PHONE_NUMBER_RULES,
  OTHER_COUNTRIES_MAX_NATIONAL_LENGTH,
  ANY_NATIONAL_NUMBER_PATTERN,
  MIN_NATIONAL_NUMBER_LENGTH,
  PHP_NUMERIC_PREFIX_PATTERN,
}
